import '../App.css';
import WideShot from '../assets/WideShot.jpg';

const About = () => {
    return (
        <div className="About">
            <div className='Header'>
                ABOUT
            </div>
            <div className='Section'>
                <div className='Introduction'>
                <img src={WideShot} alt='Sangwook Lee' style={{ width: '300px', maxWidth: '420px'}}></img>
                <div>
                    <br/>&ensp;&ensp;&ensp;&ensp;Hello! I am Sangwook Lee, a computer science graduate 
                    at the University of Toronto and current Software Engineer Consultant at FDM!
                    I have experiences with a wide range of tech stacks from React web apps, to C# backend, PostgreSQL data management, 
                    LAMP stack websites using PHP and MySQL, and more!<br/><br/>
                    &ensp;&ensp;&ensp;&ensp;I am hoping to further develop my skills as a full stack developer, with a  
                    strong passion for making interactable and responsive data interfaces that allow for clear, accurate business decisions.
                </div>
                </div>
            </div>
        </div>
    );
}

export default About;